import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _assertThisInitialized from "@babel/runtime-corejs3/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime-corejs3/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = _Reflect$construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !_Reflect$construct) return false;
  if (_Reflect$construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(_Reflect$construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018,2020. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */


import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Dialog } from '@govhhs/govhhs-design-system-react';
import { injectIntl, intlShape } from 'react-intl';
import translations from './SessionTimeoutDialogComponentMessages';
import { ID } from './constants';
/**
 * The Signup component allows the user to create a new account.
 *
 * @export
 * @class SessionTimeoutComponent
 * @extends {Component}
 */

var SessionTimeoutDialogComponent = /*#__PURE__*/function (_Component) {
  _inherits(SessionTimeoutDialogComponent, _Component);

  var _super = _createSuper(SessionTimeoutDialogComponent);
  /**
   *Creates an instance of SessionTimeoutDialogComponent.
   * @param {*} props
   * @memberof SessionTimeoutDialogComponent
   */


  function SessionTimeoutDialogComponent(props) {
    var _this;

    _classCallCheck(this, SessionTimeoutDialogComponent);

    var inactivityDialogCount = props.inactivityDialogCount;

    var _minuteCount = inactivityDialogCount >= 60 ? Math.floor(inactivityDialogCount / 60) : 0;

    var _secondCount = inactivityDialogCount % 60;

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.timer = window.setInterval(_this.countdown, 1000); // listen for the back button event and close the modal to resume the users
      // current session.

      window.addEventListener('popstate', _this.handlePopState);
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      clearInterval(_this.timer);
      window.removeEventListener('popstate', _this.handlePopState);
    });

    _defineProperty(_assertThisInitialized(_this), "handlePopState", function () {
      var onStaySignedIn = _this.props.onStaySignedIn;
      onStaySignedIn();
    });

    _defineProperty(_assertThisInitialized(_this), "countdown", function () {
      _this.setState(_this.countdownTimerUpdate, _this.countdownSetStateCallback);
    });

    _defineProperty(_assertThisInitialized(_this), "countdownTimerUpdate", function (prevState) {
      if (prevState.minuteCount > 0) {
        if (prevState.secondCount === 0) {
          return {
            minuteCount: prevState.minuteCount - 1,
            secondCount: 59
          };
        }

        return {
          minuteCount: prevState.minuteCount,
          secondCount: prevState.secondCount - 1
        };
      }

      return {
        secondCount: prevState.secondCount - 1
      };
    });

    _defineProperty(_assertThisInitialized(_this), "countdownSetStateCallback", function () {
      var onSignOutAndRedirectToLogin = _this.props.onSignOutAndRedirectToLogin;

      if (_this.state.minuteCount === 0 && _this.state.secondCount === 0) {
        clearInterval(_this.state.timer);
        onSignOutAndRedirectToLogin(true);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleSignOutButton", function () {
      var onSignOutAndRedirectToLogin = _this.props.onSignOutAndRedirectToLogin;
      onSignOutAndRedirectToLogin(false);
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var _context, _context2, _context3, _context4;

      var _this$props = _this.props,
          intl = _this$props.intl,
          onStaySignedIn = _this$props.onStaySignedIn;
      var _this$state = _this.state,
          minuteCount = _this$state.minuteCount,
          secondCount = _this$state.secondCount;
      var titleText = intl.formatMessage(translations.title);
      var logOutBtnText = intl.formatMessage(translations.signOutButton);
      var stayLoggedInBtnText = intl.formatMessage(translations.stayButton);
      return /*#__PURE__*/React.createElement(Dialog, {
        ariaLabel: _concatInstanceProperty(_context = "").call(_context, intl.formatMessage(translations.titleAriaLabel, {
          titleText: titleText,
          logOutBtnText: logOutBtnText,
          stayLoggedInBtnText: stayLoggedInBtnText
        })),
        blocking: true,
        "data-testid": ID.SESSION_TIMEOUT_MODAL_DIALOG_ID,
        onActionButtonClick: onStaySignedIn,
        open: true,
        primaryButton: /*#__PURE__*/React.createElement(Button, {
          category: "primary",
          "data-testid": ID.SESSION_TIMEOUT_MODAL_DIALOG_STAY_LOGGED_IN_BUTTON_ID
        }, stayLoggedInBtnText),
        secondaryButton: /*#__PURE__*/React.createElement(Button, {
          category: "link",
          "data-testid": ID.SESSION_TIMEOUT_MODAL_DIALOG_STAY_SIGN_OUT_BUTTON_ID,
          onClick: _this.handleSignOutButton
        }, logOutBtnText),
        title: intl.formatMessage(translations.title)
      }, /*#__PURE__*/React.createElement("p", {
        "data-testid": ID.SESSION_TIMEOUT_MODAL_DIALOG_INFORMATIONAL_MESSAGE_ID
      }, intl.formatMessage(translations.primaryMsg)), /*#__PURE__*/React.createElement("p", {
        "data-testid": ID.SESSION_TIMEOUT_MODAL_DIALOG_COUNTDOWN_TIMER_ID
      }, intl.formatMessage(translations.timerHeading), /*#__PURE__*/React.createElement("b", {
        role: "timer"
      }, /*#__PURE__*/React.createElement("span", null, minuteCount < 10 ? _concatInstanceProperty(_context2 = " 0").call(_context2, minuteCount) : minuteCount), _this.state.minuteCount < 2 ? /*#__PURE__*/React.createElement("span", null, ":", secondCount < 10 ? _concatInstanceProperty(_context3 = "0").call(_context3, secondCount) : _concatInstanceProperty(_context4 = "").call(_context4, secondCount)) : null)));
    });

    _this.state = {
      timer: null,
      minuteCount: _minuteCount,
      secondCount: _secondCount
    };
    return _this;
  }
  /**
   * Start the session timeout countdown timer. Register an event listener for
   * browser back button events.
   *
   * @memberof SessionTimeoutDialogComponent
   */


  return SessionTimeoutDialogComponent;
}(Component);

SessionTimeoutDialogComponent.propTypes = process.env.NODE_ENV !== "production" ? {
  inactivityDialogCount: PropTypes.number.isRequired,
  intl: intlShape.isRequired,
  onSignOutAndRedirectToLogin: PropTypes.func.isRequired,
  onStaySignedIn: PropTypes.func.isRequired
} : {};
export default injectIntl(SessionTimeoutDialogComponent);